import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { ShoppingCart, Search, User, LogOut, LayoutDashboard } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [menu, setMenu] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    nav(`/products${q ? `?search=${encodeURIComponent(q)}` : ""}`);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 backdrop-blur-xl bg-white/80">
      <div className="nx-container flex items-center gap-6 py-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 shrink-0">
          <div className="w-9 h-9 bg-slate-900 flex items-center justify-center">
            <span className="text-[#A3E635] font-black text-lg leading-none">N</span>
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-black text-lg tracking-tighter">NEXARA</span>
            <span className="mono text-[9px] text-slate-500">GLOBAL/TRADE</span>
          </div>
        </Link>

        <form onSubmit={submit} className="hidden md:flex flex-1 max-w-2xl border border-slate-900 focus-within:ring-2 focus-within:ring-slate-900">
          <select className="mono text-[11px] px-3 border-r border-slate-900 bg-slate-50 outline-none" data-testid="search-category">
            <option>ALL/CATEGORIES</option>
            <option>ELECTRONICS</option>
            <option>FASHION</option>
            <option>INDUSTRIAL</option>
            <option>HOME</option>
          </select>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="search-input"
            placeholder="Search 10M+ products, suppliers..."
            className="flex-1 px-4 py-2 outline-none text-sm"
          />
          <button type="submit" data-testid="search-submit" className="px-5 bg-slate-900 text-white hover:bg-slate-800 transition-colors">
            <Search size={18} />
          </button>
        </form>

        <nav className="flex items-center gap-1 ml-auto">
          <Link to="/enterprises" data-testid="nav-enterprises" className="hidden md:block px-3 py-2 text-sm hover:text-blue-700 transition-colors">Enterprises</Link>
          <Link to="/products?marketplace=b2b" data-testid="nav-b2b" className="hidden md:block px-3 py-2 text-sm hover:text-blue-700 transition-colors">Wholesale</Link>
          <Link to="/cart" data-testid="cart-link" className="relative px-3 py-2 hover:bg-slate-100 transition-colors">
            <ShoppingCart size={20} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-[#A3E635] text-emerald-950 text-[10px] font-black min-w-[18px] h-[18px] flex items-center justify-center px-1">{count}</span>
            )}
          </Link>
          {user ? (
            <div className="relative">
              <button data-testid="user-menu-btn" onClick={() => setMenu(!menu)} className="flex items-center gap-2 px-3 py-2 hover:bg-slate-100 transition-colors">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-7 h-7 rounded-full object-cover" />
                ) : (
                  <div className="w-7 h-7 bg-slate-900 text-white flex items-center justify-center text-xs font-bold">{user.name?.[0]?.toUpperCase() || "U"}</div>
                )}
                <span className="hidden md:block text-sm font-medium max-w-[100px] truncate">{user.name}</span>
              </button>
              {menu && (
                <div className="absolute right-0 top-full mt-1 w-52 bg-white border border-slate-200 shadow-xl" onMouseLeave={() => setMenu(false)}>
                  <Link to="/dashboard" data-testid="menu-dashboard" className="flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-slate-50">
                    <LayoutDashboard size={14} /> Dashboard
                  </Link>
                  <button onClick={() => { logout(); setMenu(false); nav("/"); }} data-testid="menu-logout" className="w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-slate-50 text-left">
                    <LogOut size={14} /> Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="px-3 py-2 text-sm hover:text-blue-700 transition-colors">Sign in</Link>
              <Link to="/register" data-testid="nav-register" className="nx-btn-primary text-sm">Join Free</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
